import type { ReactElement } from 'react';
import Tooltip from '@mui/material/Tooltip';

/**
 * Wraps a write action button: when `reason` is set the child is expected to be
 * disabled, and the tooltip explains why (a span keeps the tooltip working on a
 * disabled button).
 */
export default function WriteGuard({
  reason,
  children,
}: {
  reason: string | null;
  children: ReactElement;
}) {
  if (!reason) return children;
  return (
    <Tooltip title={reason}>
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
}
